import { render } from "./index.vue?vue&type=template&id=5dea2f8d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5dea2f8d&lang=less&scoped=true"

import exportComponent from "C:\\code\\zfb_xf_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dea2f8d"]])

export default __exports__